import { EventEmitter, Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { Subscription } from "rxjs/internal/Subscription";

@Injectable({
  providedIn: "root",
})
export class ApsServiceService {
  invokeFirstComponentFunction = new EventEmitter();
  invokeUserreg = new EventEmitter();
  envelop = new EventEmitter();
  subsVar: Subscription;
  public payload: any;
  public header: any;
  public headertokrn: any;
  public suggheader: any;
  public altertext: any;
  public val1: any;
  public val2: any;
  
  apitoken: any = localStorage.getItem("token");
  constructor(private http:HttpClient, private router: Router) {
    this.header = new HttpHeaders()
    .set('content-type', 'application/json')
    .set('access-control-request-token',environment.accesstoken)
    .set('Access-Control-Allow-Origin', '*')
    .set("Access-Control-Allow-Headers", "Origin, X-Requested-With")
    // .set("ApiKey","efa81eb6-e879-4027-9e51-73fbf069d33d")
    .set("Api-Key",environment.apisearchkey)

   }


   getDonatioinPage(usermails,username,Description) {
    // //console.log(searchkey);
    var donations = {

      useremail:usermails,
      username:username,
      description:Description,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/donation`, donations, {
        headers: this.header,

      })
      .pipe(
        map((result) => {
          console.log(result);
          return result;
        })
      );
  }
  
  basesearch(cnt: any) {
    //console.log(cnt);
    return this.http
      .get<any>(`${environment.getapssearch}` + cnt+ '&$top=10', {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          // this.altertext=result.queryContext.alteredQuery

          return result;
        })
      );
  }

  searchParam(searchkey: any) {
    // //console.log(searchkey);
    return this.http
      .get<any>(`${environment.apssuggest}` + searchkey, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          // //console.log(result);
          return result;
        })
      );
  }
  Getusernamebyemail(searchkey: any) {
    //console.log(searchkey);
    var datas = {
      username: searchkey,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/checkuserbyemail`, datas, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  Getusername(searchkey: any) {
    //console.log(searchkey);
    var datas = {
      username: searchkey,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/checkuser`, datas, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  CheckUseremail(email){
    var datas = {
       email:email
    };
    return this.http.post<any>(`${environment.apiencode}api/checkEmailer`,datas,{headers: this.header})
    .pipe(map(result => {
       //console.log(result);
          return result;
          
      }));
  }
 
  getLoginPackage() {

    var payload={}

    return this.http
      .post<any>(`${environment.apiencode}api/packages`,payload,{ headers: this.header }
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }
  regUserData(
    datas: any,
    username: any,
    password: any,
    getplanyear: any,
    getplanname: any,
    getplanamount: any
  ) {
    //console.log(datas);

    var payload = {
      username: username,
      password: password,
      directoryAccess: datas.optradio,
      planId: 2,
      Donation: 20,
      FirstName: datas.Firstname,
      LastName: datas.lastName,
      Email: datas.email,
      Phone: datas.Phone,
      Address_1: datas.address1,
      Address_2: datas.address2,
      zip: datas.zip,
      city: datas.city,
      State: datas.state,
      Country: datas.Country,
      planyear: getplanyear,
      planname: getplanname,
      planamout: getplanamount,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/registration`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  logindata(datas) {
    var payload = {
      username: datas.username,
      password: datas.password,
    };

    return this.http
      .post<any>(`${environment.apiencode}api/login`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  resetPassword(data) {
    var payload = {
      username: data,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/forgetpassword`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

deleteresertoken(id) {
    var payload = {
      userid: id,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/deletetoken`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  setOtp(username, otp) {
    var payload = {
      username: username,
      usertoken: otp,
    };
    //console.log(payload);
    return this.http
      .post<any>(`${environment.apiencode}api/verifyToken`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  ChangePassword(passwords, userid) {
    var payload = {
      password: passwords,
      userid: userid,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/resetpassword`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  pastevent(pagenumber: any, limit: any) {
    //   var payload={
    //   "password":passwords,
    //   "userid":userid

    // }
    //console.log(pagenumber);
    //console.log("liomit" + limit);
    return this.http
      .post<any>(
        `${environment.apiencode}api/events/past/` + limit + "/" + pagenumber,{},
        { headers: this.header }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  futureevent(pagenumber: any, limit: any) {
    //   var payload={
    //   "password":passwords,
    //   "userid":userid

    // }
    //console.log(pagenumber);
    //console.log("liomit" + limit);
    return this.http
      .post<any>(
        `${environment.apiencode}api/events/future/` + limit + "/" + pagenumber,{},
        { headers: this.header }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  geteventdetails(data) {
    return this.http
      .post<any>(`${environment.apiencode}api/events/eventdetails/` + data,{},{
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  product(data) {
    //console.log(data);
    return this.http
      .post<any>(`${environment.apiencode}api/shop/shopitemitem/` + data,{}, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  productdetails(data) {
    //console.log(data);
    return this.http
      .post<any>(`${environment.apiencode}api/shop/details/` + data,{}, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  ContactResponce(data: any) {
    var payload = {
      username: data.name,
      usermail: data.email,
      usernumber: data.phone,
      subject: data.message,
      location: data.location,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/contact/`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  uploaduser(userid, datas,flag) {
    var payload = {
      userid: parseInt(userid),
      FirstName: datas.Firstname,
      LastName: datas.lastname,
      Email: datas.email,
      Phone: datas.phone,
      Address_1: datas.address1,
      Address_2: datas.address2,
      zip: datas.zip,
      city: datas.city,
      State: datas.state,
      Country: datas.country,
      directory: datas.Access,
      username: datas.username,
      password: datas.password,
      flag:flag,


    };
    //console.log(payload)
    return this.http
      .post<any>(`${environment.apiencode}api/upload`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getUserdata(data) {
    var payload = {
      userid: data,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/getuserdata`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  getcollect(pageno: any, pagelimit: any) {
    return this.http
      .post<any>(
        `${environment.apiencode}api/article/articles/` +
          pagelimit +
          "/" +
          pageno,{},
        {
          headers: this.header
        }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getereader(pageno: any, pagelimit: any) {
    return this.http
      .post<any>(
        `${environment.apiencode}api/ereader/ereaders/` +
          pagelimit +
          "/" +
          pageno,{},
        {
          headers: this.header
        }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getcategory(pageno: any, pagelimit: any) {
    return this.http
      .post<any>(
        `${environment.apiencode}api/category/categorys/` +
          pagelimit +
          "/" +
          pageno,{},
        {
          headers: this.header
        }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }




  getcollectDetails(id: any) {
    return this.http
      .post<any>(`${environment.apiencode}api/article/articledetails/` + id,{}, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getProductitemsShop() {
    var payload = {
      userid: 1,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/shop/viewcart`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  subscription(payload: any) {
    return this.http
      .post<any>(`${environment.apiencode}api/user/subscription`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  getSub(userid: any) {
    var payload = {
      userid: userid,
    };
    return this.http
      .post<any>(`${environment.apiencode}api/user/getSubscription`, payload, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getMembers(pageno: any, pagelimit: any) {
    return this.http
      .post<any>(
        `${environment.apiencode}api/members`,{},
        { headers: this.header }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getMemberssearch(data) {
    var payload={
      "search":data
    }
    return this.http.post<any>(`${environment.apiencode}api/searchmember`,payload,
        { headers: this.header }
      )
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }


  linkItemsdatas() {
    return this.http
      .post<any>(`${environment.apiencode}api/get/link`,{}, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getTop3(){
    return this.http
      .post<any>(`${environment.apiencode}api/ereader/topdata`,{}, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  getnoify() {
    return this.http
      .post<any>(`${environment.apiencode}api/get/notify`,{}, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  // payments

  payment(payments, payloader) {
    var datasets = {
      payment: payments,
      listcart: payloader,
    };

    //console.log(datasets);

    return this.http
      .post<any>(`${environment.apiencode}payment/payitem`, datasets, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  paymentSuccess(payments, paymentitem,storedata) {
    var datasets = {
      payment: payments,
      itemids: paymentitem,
      dataset: storedata,
      cartstore:storedata
    };
    //console.log(datasets);
    return this.http
      .post<any>(`${environment.apiencode}payment/requestsuccess`, datasets, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }

  paymentInsert(paymentinfo,paymentdetails,total,paymentInsert){
    var datasets = {
      paymentinfo: paymentinfo,
      paymentdetails: paymentdetails,
      total:total,
      placeoforder:paymentInsert
    };
    //console.log(datasets);
    return this.http
      .post<any>(`${environment.apiencode}payment/addcartinfo`, datasets, {
        headers: this.header,
      })
      .pipe(
        map((result) => {
          //console.log(result);
          return result;
        })
      );
  }
  
// get user payment request

regPayment(payments, payloader) {
  var datasets = {
    payment: payments,
    listcart: payloader,
  };

  //console.log(datasets);

  return this.http
    .post<any>(`${environment.apiencode}payment/userregpayitem`, datasets, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}
paymentSuccessreg(payments, paymentitem) {
  var datasets = {
    payment: payments,
    itemids: paymentitem,
  };
  //console.log(datasets);
  return this.http
    .post<any>(`${environment.apiencode}payment/requestregsuccess`, datasets, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}


// get user payment request

subPayment(payments, payloader) {
  var datasets = {
    payment: payments,
    listcart: payloader,
  };

  //console.log(datasets);

  return this.http
    .post<any>(`${environment.apiencode}payment/usersubpayitem`, datasets, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}
paymentSuccesssubs(payments, paymentitem) {
  var datasets = {
    payment: payments,
    itemids: paymentitem,
  };
  //console.log(datasets);
  return this.http
    .post<any>(`${environment.apiencode}payment/requestregsuccess`, datasets, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}


//  get search doc files

getsearchdocs() {
  return this.http
    .post<any>(`${environment.apiencode}api/searchdata/getSearchcatadata`,{}, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}

getadvisorymember() {
  return this.http
    .post<any>(`${environment.apiencode}api/board/getadvisorymember`,{}, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}
getboard() {
  return this.http
    .post<any>(`${environment.apiencode}api/board/getboardmember`,{}, {
      headers: this.header,
    })
    .pipe(
      map((result) => {
        //console.log(result);
        return result;
      })
    );
}

// login Pcakage 
getLoginsubPackage() {

  var payload={}

  return this.http
    .post<any>(`${environment.apiencode}api/sub-package`,payload,{ headers: this.header }
    )
    .pipe(
      map((result) => {
        return result;
      })
    );
}
ifchekexpire(id) {

  var payload={
    "userid":id
  }

  return this.http
    .post<any>(`${environment.apiencode}api/chekexpire`,payload,{ headers: this.header }
    )
    .pipe(
      map((result) => {
        return result;
      })
    );
}



  onFirstComponentButtonClick() {
    this.invokeFirstComponentFunction.emit();
  }
  onFirstComponent() {
    this.invokeUserreg.emit();
  }

  contactUs() {
    this.envelop.emit();
  }
}
